import { CHANGE_FILTERS_STATE } from "store/reducers/filter/filters/types"
import { AppDispatch } from "store"

export const setFiltersOpen = (isOpen: boolean): any => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: CHANGE_FILTERS_STATE,
      isOpen
    })
  }
}